/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len*/
/* eslint-disable react/no-array-index-key */
import React, { useRef, useState } from 'react';
import Collapsible from 'react-collapsible';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Banner from './Banner';

// Toogles the banner collapse.
const triggerCollapse = (event) => {
  event.preventDefault();
  event.stopPropagation();
  document.querySelector('.Collapsible__trigger').click();
};

// Toogles the banner collapse on scroll down.
const triggerCollapseOnScrollDown = (event) => {
  const scroll = window.pageYOffset || document.body.scrollTop;
  if (0 < scroll) {
    triggerCollapse(event);
    window.removeEventListener('scroll', triggerCollapseOnScrollDown);
  }
};

// Fills the circle progress icon for the banner rotations.
const decreaseStrokeDashoffset = (currentStrokeDashoffset) => {
  /* If currentStrokeDashoffset is falsey return the initial css value for it.
  We use 49 and not 50 so it doesn't rotate before looping at least once */
  if (! currentStrokeDashoffset) {
    return 49;
  }
  const strokeDashoffset = parseInt(currentStrokeDashoffset.replace('px', ''), 10);
  // If the progress circle is not full, keep filling it.
  return 5 < strokeDashoffset ? strokeDashoffset - 2 : 50;
};

const Banners = ({
  banners,
  totalLength,
}) => {
  const [intervalStarted, setIntervalStarted] = useState(false);
  const [topBanner, setTopBanner] = useState(false);
  const [openedOverlay, setOpenedOverlay] = useState(false);
  const [moreAlertText, setMoreAlertText] = useState('');
  const intervalID = useRef(false);
  const topBannerPosition = useRef(0);
  const bannerQuantity = banners.length;
  let bannersCollapse = null;

  const className = clsx(
    'alert-banners',
    {
      'has-messages': true,
    },
  );

  const alertsOpenedOverlay = openedOverlay
    ? <div className="alert-banners-opened-overlay" /> : null;

  if (1 <= bannerQuantity) {
    /* Only Initiate Interval and Collapse trigger if there are 2 or more banners.
    We also ask if the interval has started to not start several intervals on state change. */
    if (1 < bannerQuantity && ! intervalStarted) {
      setMoreAlertText(`${totalLength - 1} MORE ALERTS`);
      intervalID.current = setInterval(() => {
        const bannerLoadingRotator = document.querySelector('.circle-progress');
        if (bannerLoadingRotator) {
          const strokeDashoffsetUpdated = decreaseStrokeDashoffset(bannerLoadingRotator.style.strokeDashoffset);

          bannerLoadingRotator.style.strokeDashoffset = strokeDashoffsetUpdated;
          // If the circle progress animation already looped, change banner.
          if (50 === strokeDashoffsetUpdated) {
            topBannerPosition.current = topBannerPosition.current < bannerQuantity - 1
              ? topBannerPosition.current + 1 : 0;

            setTopBanner(banners[topBannerPosition.current]);
          }
        }
      }, 200);

      setIntervalStarted(true);
    }

    /*
      Since the value of topBannerPosition uses the useRef hook to survive state changes
      it will not trigger a render by itself, so we use setTopBanner for that.
      This is done so that the topBanner only changes with the interval rotations.
    */
    const firstBanner = topBanner || banners[topBannerPosition.current];

    bannersCollapse = (
      <div className={className}>
        {alertsOpenedOverlay}
        <Banner
          {...firstBanner}
          moreAlertText={moreAlertText}
          isFirst
          triggerCollapse={triggerCollapse}
        />
        <Collapsible
          trigger={(
            <span className="alert-banner__more-messages">
              {moreAlertText}
            </span>
          )}
          transitionTime={100}
          onTriggerOpening={() => {
            topBannerPosition.current = 0;
            setTopBanner(banners[0]);
            setMoreAlertText('COLLAPSE ALERTS');
            setOpenedOverlay(true);
            // Stops Interval
            if (intervalID.current) {
              clearInterval(intervalID.current);
            }
            // Adds is-open class to the custom trigger as well.
            document.querySelector('#more-alert-trigger').classList.add('is-open');
            // Reset rotation progress animation.
            document.querySelector('.circle-progress').style.strokeDashoffset = 49;
          }}
          onTriggerClosing={() => {
            // Starts Interval.
            setIntervalStarted(false);
            setMoreAlertText(`${totalLength - 1} MORE ALERTS`);
            setOpenedOverlay(false);
            // Removes is-open class from the custom trigger as well.
            document.querySelector('#more-alert-trigger').classList.remove('is-open');
          }}
          onOpen={() => {
            document.querySelector('.alert-banners-opened-overlay')
              .addEventListener('click', triggerCollapse);

            window.addEventListener('scroll', triggerCollapseOnScrollDown);
          }}
          onOClose={() => {
            document.querySelector('.alert-banners-opened-overlay')
              .removeEventListener('click', triggerCollapse);
          }}
        >
          {banners.map((banner, index) => {
            // The first banner is already rendered since it will be always visible, so we skip it.
            if (0 >= index) {
              return null;
            }
            return <Banner key={`${banner.type}${index}`} position={index + 1} {...banner} />;
          })}
        </Collapsible>
      </div>
    );
  }

  return bannersCollapse;
};

Banners.propTypes = {
  banners: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  wales: PropTypes.array, // eslint-disable-line react/forbid-prop-types
};

Banners.defaultProps = {
  banners: [],
  wales: null,
};

export default Banners;
